import coverPhoto from '../assets/hotspot/celebrationCover/green-corn-ceremony-2.jpg';
import marthaImage from '../assets/hotspot/headerImages/martha-l-2.jpg';
import cellebrationThumbnail1 from '../assets/hotspot/celebrationPerformances/martha-social-dances.png';
import cellebrationThumbnail2 from '../assets/hotspot/celebrationPerformances/martha_social_dances_concert.png';


export const greenCornCeremony = {
  celebrationTitle: 'Green Corn Ceremony',
  startDate: '06-22',
  endDate: '07-31',
  filterValue: 'greenCornCeremony',
  celebrationImage: coverPhoto,
  displayDate: 'Late June through July',
  description: ' The Green Corn Ceremony is a multi-day festival celebrated by various Southeastern Native American tribes at the beginning of the corn harvest. The festival is a celebration of many types of new beginnings and includes camping on the land, dancing, working together to prepare the ceremony, and fasting.',
  celebrationVideos: [
    {
      videoLink: 'https://youtu.be/BwaKrhD0uAg',
      videoImage: cellebrationThumbnail1,
      songTitle: 'Social Dances',
      artistName: 'Martha',
      videoTags: [
        {
          tag: 'Green Corn Ceremony',
        },
      ],
      songDescription: 'These songs are tribal social dances from the Cherokee and Choctaw tribes. Social dances are performed at powwows, gatherings that bring together members of different tribes. Because each tribe has its own language, the lyrics are  vocables—syllables like “la la la,” so everyone can sing together. The lyrics are accompanied by percussion, and the dance movements express the meaning of the dance.',
    },
    {
      videoLink: 'https://youtu.be/BOHwnB_jXSQ',
      videoImage: cellebrationThumbnail2,
      songTitle: 'Social Dances',
      artistName: 'Martha',
      videoTags: [
        {
          tag: 'Green Corn Ceremony',
        },
      ],
    },
  ],
  artistsWhoCelebrate: [
    {
      artistName: 'Martha',
      artistId: 'martha',
      artistImage: marthaImage,
    },
  ],
};
